/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_OlaInputs */

const en_platform_preview_ola = /** @type {(inputs: Platform_Preview_OlaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ola Kowalska · 1:1 session`)
};

const pl_platform_preview_ola = /** @type {(inputs: Platform_Preview_OlaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ola Kowalska · Trening 1:1`)
};

/**
* | output |
* | --- |
* | "Ola Kowalska · 1:1 session" |
*
* @param {Platform_Preview_OlaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_ola = /** @type {((inputs?: Platform_Preview_OlaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_OlaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_ola(inputs)
	return en_platform_preview_ola(inputs)
});